<template>
  <div class="mb-5 p-3 bg-white rounded-md">
    <div class="row no-gutters">
      <!-- 圖文簡介 begin -->
      <div class="col-12 col-lg-5 pr-0 pr-lg-3 mb-3 mb-lg-0">
        <!-- 標籤 begin -->
        <div class="position-absolute" style="left:12px;top:8px;z-index:10" v-if="gift.specialTag !== ''">
          <span class="badge badge-dark rounded-pill px-2 bg-customize">{{ gift.specialTag }}</span>
        </div>
        <!-- 標籤 end -->
        <figure class="m-0 mb-lg-3">
          <img :src="gift.mainImage" alt="" class="mw-100">
        </figure>
      </div>
      <div class="col-12 col-lg-7">
        <div class="h-100 d-flex flex-column">
          <h2 class="h4 text-truncate-2">{{ gift.name }}</h2>
          <p class="font-size-md text-gray600 mb-5">{{ gift.shortDesc }}</p>
          <hr class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <span class="h4 text-danger font-weight-bold mr-2">{{ gift.point }}</span>
              <span class="font-size-md text-gray600">{{ pointUnit }}
                <span>
                  ( {{ $t('gift.remain-amount-of-purchase', { amount: gift.soh }) }} )
                </span>
              </span>
            </div>
            <div>
              <!--
              <a href="javascript:void(0)" class="icon-animate icon-animate-sm"><span class="material-icons text-gray600">card_giftcard</span></a>
              <a href="javascript:void(0)" class="icon-animate icon-animate-sm"><span class="material-icons text-gray600">share</span></a>
              -->
              <a href="javascript:void(0)" class="d-block p-2 text-decoration-none" v-stream:click="favoriteClick$">
                <template v-if="isFavorite">
                  <span class="d-block material-icons text-customize">favorite</span>
                </template>
                <template v-else>
                  <span class="d-block material-icons text-gray600">favorite_border</span>
                </template>
              </a>
            </div>
          </div>
          <hr class="w-100 mb-4">
          <template v-if="hasMemberTypeLimit">
            <div class="d-flex align-items-center flex-wrap mb-3">
              <template v-for="(item, index) in limitMemberTypeSetting">
                <span :key="index" class="text-nowrap mr-3 mb-1">
                  <span class="image-panel image-panel-n2 bg-none">
                    <img :src="item.iconPic" :alt="item.name" class="w-100">
                  </span>
                  <span>{{ `${item.name}${$t('global.limit')}` }}</span>
                </span>
              </template>
            </div>
          </template>

          <template v-if="hasLogin">

            <template v-if="canBuy">
              <div class="position-relative">
                <!--按+之後才出現，手機板是animate__fadeOutDownBig 電腦版是animate__fadeOutUpBig-->
                <h2 v-if="animationShow" class="text-customize position-absolute animate__animated" :class="isMobile ? 'animate__fadeOutDownBig' : 'animate__fadeOutUpBig'" style="z-index:30;font-size:5rem;top:0">+1</h2>
                <b-form-spinbutton id="demo-sb" min="0" :max="exchangeableQty" size="" :value="myBuyCount" v-stream:change="countChange$" placeholder="0" class="bg-white w-100" style="max-width:280px;"></b-form-spinbutton>
              </div>
              <p class="font-size-md text-gray600">{{ redeemLimitHint }}</p>
            </template>

            <template v-else-if="gift.limitedRedeemType !== 0 && limitedQtyByType <= 0">
              <div class="text-danger">{{ reachLimitWording }}</div>
            </template>

            <template v-else>
              <div>
                <b-progress height="6px" :max="canNotBuyHintObj.max" class="rounded-pill mt-2" style="max-width:360px;">
                  <b-progress-bar :value="canNotBuyHintObj.value" class="bg-gray500"></b-progress-bar>
                </b-progress>
                <div class="font-size-sm">{{ canNotBuyHintObj.hint }}</div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <!-- 圖文簡介 end -->
      <div class="col-12"><hr></div>
      <!-- 內容詳細說明 begin -->
      <article class="col-12 font-size-md text-gray600" v-html="gift.desc" />
      <!-- 內容詳細說明 end -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { throwError } from 'rxjs';
import {
  tap, debounceTime, filter, map,
} from 'rxjs/operators';
import store from '@/store/index';
import pageSettingGetter from '@/utils/pageSettingGetter';
import pdiService from '@/services/pdiService';

export default {
  props: {
    gift: Object,
  },
  data() {
    return {
      // 所有會籍設定
      memberTypeSetting: [],
      // 我的購買數量
      myBuyCount: 0,
      // 我的點數
      myPoint: 0,
      // 我的該會籍內消費點數
      myTotalAmount: 0,
      // 我的會籍
      myMemberType: '',
      // 顯示動畫
      animationShow: false,
      // 積點單位
      pointUnit: '',
      // 點數未達到文案
      pointInsufficientWording: '',
      // 會籍未達到文案
      memberTypeInsufficientWording: '',
      // 已達限購數文案
      reachLimitWording: '',
      // 兌換文案
      exchangeWording: '',
      // 一周開始日
      weekType: 0,
      // 兌禮商品兌換時間
      redeemTime: [],
      // 資料是否完成載入
      loadingCompleted: false,
    };
  },
  domStreams: ['countChange$', 'favoriteClick$'],
  beforeRouteEnter(to, from, next) {
    // 檢查兌禮商品資料是否由params傳入
    if (to.params.gift) {
      next();
      return;
    }

    // 呼叫API取得兌禮商品資料
    const body = {
      companyId: store.state.companyId,
      deptNo: [],
      redeemItemNo: [Number(to.params.no)],
      keyword: '',
      limit: 1,
      offset: 0,
      // 撈取全部商品資料且前台可顯示
      activeType: 4,
    };

    pdiService.getRedeemItems(body).pipe(
      map((res) => {
        // API錯誤 ; 沒取資料
        if (res.response.status !== '200' || res.response.data.length === 0) throwError();
        return res.response.data[0];
      }),
    ).subscribe({
      // 將取回的資料放入params中
      next: (gift) => {
        to.params.gift = gift;
        next();
      },
      // 取得失敗，導頁到兌禮列表
      error: () => { next({ name: 'redeemList' }); },
    });
  },
  created() {
    const vm = this;
    // 取得全部會籍設定
    const getMemberTypeSetting = vm.$store.dispatch('getMemberTypeSetting').then((setting) => {
      vm.memberTypeSetting = setting;
    });

    // 取得頁面基礎設定
    const getPageSetting = vm.$store.dispatch('getPageSetting', 'RedeemItem').then((setting) => {
      vm.pointUnit = pageSettingGetter.getFunctionWording(setting, 'UserPointUnit');
      vm.pointInsufficientWording = pageSettingGetter.getFunctionWording(setting, 'PointInsufficientPromote');
      vm.memberTypeInsufficientWording = pageSettingGetter.getFunctionWording(setting, 'MemberTypeInsufficientPromote');

      vm.reachLimitWording = pageSettingGetter.getFunctionWording(setting, 'RedeemLimitFullWording');
      vm.exchangeWording = pageSettingGetter.getFunctionWording(setting, 'RedeemWording');
    });

    let getMemberType = Promise.resolve();
    let getMemberBonus = Promise.resolve();
    let getCompanyPermission = Promise.resolve();
    let getRedeemTime = Promise.resolve();

    if (vm.hasLogin) {
      // 取得會員會籍
      getMemberType = vm.$store.dispatch('getMemberType').then((memberType) => {
        vm.myTotalAmount = memberType.currentAmount;
        vm.myMemberType = memberType.currentLevelId;
      });

      // 取得會員積點
      getMemberBonus = vm.$store.dispatch('getMemberBonus');
      getMemberBonus.then((memberBonus) => {
        vm.myPoint = memberBonus.pointSum;
      });

      // 取得公司資訊
      getCompanyPermission = vm.$store.dispatch('getCompanyPermission');
      getCompanyPermission.then((companyPermission) => {
        vm.weekType = companyPermission.weekType;
      });

      // 取得兌禮商品兌換時間
      getRedeemTime = vm.$store.dispatch('redeemItem/getRedeemTime');
      getRedeemTime.then((redeemTime) => {
        vm.redeemTime = redeemTime;
      });
    }

    Promise.all([getMemberTypeSetting, getPageSetting, getMemberType, getMemberBonus, getCompanyPermission, getRedeemTime]).then(() => { vm.loadingCompleted = true; });

    // 第一次取得購物車資料完成後，初始化兌禮商品的購買數量
    const unWatchFn = vm.$watch('cartList', (res) => {
      if (unWatchFn) {
        unWatchFn();
      }
      vm.myBuyCount = res.find((x) => x.no === vm.gift.no) ? res.find((x) => x.no === vm.gift.no).qty : 0;
    }, {
      immediate: true,
    });
  },
  mounted() {
    const vm = this;

    // 購買數量改變
    vm.countChange$.pipe(
      filter(() => vm.hasLogin),
      tap((res) => vm.plusAnimation(res.event.msg)),
      debounceTime(500),
    ).subscribe(() => { vm.updateRedeemItemsCart({ no: vm.gift.no, qty: vm.myBuyCount, point: vm.gift.point }); });

    // 按下最愛
    vm.favoriteClick$.subscribe(() => {
      if (vm.hasLogin) {
        vm.updateMemberFavoriteRedeemItems(vm.gift.no);

        // 未登入時發送事件
      } else {
        vm.$emit('handleNonLogin');
      }
    });
  },
  computed: {
    ...mapState({
      accessToken: (state) => state.accessToken,
      cartList: (state) => state.redeemItem.cartList,
      isMobile: (state) => state.isMobile,
      favoriteItemNos: (state) => state.redeemItem.favoriteItemNos,
    }),
    // 是否已登入
    hasLogin() {
      return this.accessToken !== '';
    },
    // 是否為最愛
    isFavorite() {
      return this.favoriteItemNos.includes(this.gift.no);
    },
    // 限制購買會籍設定
    limitMemberTypeSetting() {
      return this.gift.limitedMemberType.map((x) => this.memberTypeSetting.find((y) => x === y.id) || {});
    },
    // 有會籍限制
    hasMemberTypeLimit() {
      return this.gift.limitedMemberType.length > 0;
    },
    // 點數足夠可購買
    canBuyByEnoughPoint() {
      return this.myPoint >= this.gift.point;
    },
    // 會籍足夠可購買
    canBuyByMemberType() {
      return this.gift.limitedMemberType.length === 0 || this.gift.limitedMemberType.includes(this.myMemberType);
    },
    // 可以購買
    canBuy() {
      const vm = this;

      return vm.canBuyByEnoughPoint && vm.canBuyByMemberType
      // 無限購條件 或 (有限購條件 且 限購條件下的可購買數量 > 0)
       && (vm.gift.limitedRedeemType === 0 || (vm.gift.limitedRedeemType !== 0 && vm.limitedQtyByType > 0));
    },
    // 不可購買提示相關物件
    canNotBuyHintObj() {
      const vm = this;

      if (!vm.loadingCompleted) return {};

      // 因會籍不夠不可購買
      if (!vm.canBuyByMemberType) {
        // 找出距離原會籍最近的可購買 會籍
        const nowMemberTypeSetting = vm.memberTypeSetting.find((x) => x.id === vm.myMemberType);
        const closestNextMemberTypeUpgrade = nowMemberTypeSetting.upgRule
          .filter((x) => x.type === 'Upgrade' && vm.gift.limitedMemberType.includes(x.id))
          .reduce((prev, curr) => (prev.startValue > curr.startValue ? curr : prev));

        const hint = `${vm.memberTypeInsufficientWording
          .replace(/{UpgradeAmount}/igm, closestNextMemberTypeUpgrade.startValue - vm.myTotalAmount)
          .replace(/{UpgradeType}/igm, vm.memberTypeSetting.find((x) => x.id === closestNextMemberTypeUpgrade.id).name)}`;

        return { hint, max: closestNextMemberTypeUpgrade.startValue, value: vm.myTotalAmount };
      }

      // 因點數不夠不可購買
      if (!vm.canBuyByEnoughPoint) {
        const hint = `${vm.pointInsufficientWording
          .replace(/{UserPoint}/igm, vm.gift.point - vm.myPoint)
          .replace(/{PointUnit}/igm, vm.pointUnit)}`;

        return { hint, max: vm.gift.point, value: vm.myPoint };
      }
      return {};
    },
    // 限購條件下的已兌換數量，會因為時間條件而改變數量
    limitedExchangedQty() {
      const vm = this;

      // 無限購條件，回傳0
      if (vm.gift.limitedRedeemType === 0) return 0;

      // 取得兌換紀錄
      const redeemTime = vm.redeemTime.find((x) => x.no === vm.gift.no);
      // 若無兌換紀錄，已兌換數量回傳為0
      if (!redeemTime) return 0;

      // 依兌換限制類型決定限制起始日
      const now = new Date();
      let limitDate;
      let dayOfMonth;
      switch (vm.gift.limitedRedeemType) {
        // 限量不限時間
        default:
        case 1:
          break;
        // 每周限制，計算當周起始日
        case 2:
          // 當周起始日 = 當日日期 - 星期幾(0為星期日) + 星期起始日(0為星期日)
          dayOfMonth = now.getUTCDate() - now.getUTCDay() + vm.weekType;
          // 若當周起始日未到(e.g. 當日為週日，起始日為週一)，日期減七取得上周起始日
          if (dayOfMonth > now.getUTCDate()) dayOfMonth -= 7;
          limitDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), dayOfMonth, -8));
          break;
        // 每月限制，計算當月起始日
        case 3:
          limitDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1, -8));
          break;
        // 每年限制，計算當年起始日
        case 4:
          limitDate = new Date(Date.UTC(now.getUTCFullYear(), 1, 1, -8));
          break;
      }

      // 用限制起始日找出已兌換數量
      return vm.gift.limitedRedeemType === 1 ? redeemTime.saleTimes.length : redeemTime.saleTimes.filter((x) => x > limitDate.valueOf()).length;
    },
    // 限購條件下的可兌換數量
    limitedQtyByType() {
      const vm = this;

      // 無限購條件，回傳商品庫存
      if (vm.gift.limitedRedeemType === 0) return 0;

      // 商品限購數量 > 限購條件下的已兌換數量，回傳兩者相減；小於則回傳0
      return vm.gift.limitedRedeemQty > vm.limitedExchangedQty ? vm.gift.limitedRedeemQty - vm.limitedExchangedQty : 0;
    },
    // 可兌換數量
    exchangeableQty() {
      const vm = this;

      // 無限購條件，回傳商品庫存
      if (vm.gift.limitedRedeemType === 0) return vm.gift.soh;

      // 限購條件下的可兌換數量與庫存取最小
      return Math.min(vm.limitedQtyByType, vm.gift.soh);
    },
    // 限購提醒文案
    redeemLimitHint() {
      const vm = this;

      // 無限購
      if (vm.gift.limitedRedeemType === 0) return '';

      let period = '';
      switch (vm.gift.limitedRedeemType) {
        case 4:
          period = vm.$t('global.yearly');
          break;
        case 3:
          period = vm.$t('global.monthly');
          break;
        case 2:
          period = vm.$t('global.weekly');
          break;
        case 1:
        default:
          break;
      }
      // 限購文案
      const result = vm.$t('redeem.item.limit-amount-of-purchase', { period, amount: vm.gift.limitedRedeemQty });
      // 取得兌換紀錄
      const redeemTime = vm.redeemTime.find((x) => x.no === vm.gift.no);
      // 沒買過，不需加已兌換文案
      if (!redeemTime) { return result; }

      return `${result}，${vm.$t('redeem.item.exchanged-amount', { exchange: vm.exchangeWording, amount: vm.limitedExchangedQty })}`;
    },
  },
  methods: {
    ...mapActions('redeemItem', ['updateMemberFavoriteRedeemItems', 'updateRedeemItemsCart']),
    // 增加數量動畫
    plusAnimation(value) {
      // 購買數量往上加才顯示動畫
      if (value > this.myBuyCount) {
        this.animationShow = true;
      }

      this.myBuyCount = value;
    },
  },
  watch: {
    // 動畫變更時間
    animationShow() {
      setTimeout(() => {
        this.animationShow = false;
      }, 100);
    },
  },
};
</script>

<style>

</style>
